module.exports = __webpack_public_path__ + "static/media/l-trapp-hoger.97826a89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/l-trapp-hoger.png
// module id = 42
// module chunks = 0